<template>
  <v-app>
    <v-navigation-drawer app width="246" mini-variant-width="70" clipped :mini-variant="drawerOpenedMiniVariant"
      v-model="drawerOpenedValue">
      <v-list dense>
        <v-list-tile v-for="(item, key) in drawerItems" :key="key" router :to="key" v-if="!item.invisible" ripple>
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app dark clipped-left color="primary">

      <v-toolbar-side-icon @click="drawerOpened = !drawerOpened" />

      <v-img src="./img/logo.svg" contain height="40px" width="40px" class="ml-3" style="flex: none" />

      <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp" class="ml-1">
        <span class="headline font-weight-bold success--text">Sprayer</span>
        <span class="headline font-weight-light white--text">Manager</span>
      </v-toolbar-title>

      <v-menu offset-y v-if="getAvailableRelatedViews($route.path)" attach>
        <v-btn flat slot="activator">
          {{ drawerItems[$route.path].title }}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
        <v-list light>
          <v-list-tile v-for="(item, key) in getAvailableRelatedViews($route.path)" :key="key" router :to="key">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>

      <alert-chip v-if="$store.getters.isAbbonamentoExpired" color="warning" class="ml-3">
        <v-icon small>warning</v-icon>
        <span class="ml-2">{{ $t('errori.abbonamento_scaduto') }}</span>
      </alert-chip>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-menu offset-y attach>
          <!-- Bottone che mostra la selezione -->
          <v-btn flat slot="activator">
            <v-avatar left size="30px">
              <v-icon size="30px" left>mdi-office-building</v-icon>
            </v-avatar>
            {{ selectedNumeroCentro ? selectedNumeroCentro : 'Seleziona centro' }}
            <v-icon right>keyboard_arrow_down</v-icon>
          </v-btn>

          <!-- Menu con la lista dei centri -->
          <v-list light>
            <v-list-tile v-for="(centro, index) in centri_prova" :key="index" @click="cambiaCentro(centro)">
              <v-list-tile-content>
                <v-list-tile-title>{{ centro.numero_centro }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>

      <v-toolbar-items>
        <v-menu offset-y left attach>

          <v-btn flat slot="activator">
            <!-- <v-avatar left size="30px">
              <v-icon size="30px" left></v-icon>
            </v-avatar> -->
            {{ selectedLanguage }}
            <v-icon right>keyboard_arrow_down</v-icon>
          </v-btn>

          <v-list light>
            <v-list-tile @click="changeLanguage('it')">
              <v-list-tile-action>
                <img src="../locales/flags/it.png" height="30px" width="40px">
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Italiano</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="changeLanguage('en')">
              <v-list-tile-action>
                <img src="../locales/flags/en.png" height="30px" width="40px">
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>English</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="changeLanguage('de')">
              <v-list-tile-action>
                <img src="../locales/flags/de.png" height="30px" width="40px">
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Deutsch</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="changeLanguage('pt')">
              <v-list-tile-action>
                <img src="../locales/flags/pt.png" height="30px" width="40px">
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Português</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

        </v-menu>
      </v-toolbar-items>

      <v-toolbar-items>
        <v-menu offset-y left attach>

          <v-btn flat slot="activator">
            <v-avatar left size="30px">
              <v-icon size="30px" left>account_circle</v-icon>
            </v-avatar>
            {{ (this.$store.state.session.username.split('@')[0]).replace(/\./g, ' ') }}
            <v-icon right>keyboard_arrow_down</v-icon>
          </v-btn>

          <v-list light>
            <v-list-tile router to="/impostazioni">
              <v-list-tile-action>
                <v-icon color="primary">settings</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('header.impostazioni') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action>
                <v-icon color="primary">exit_to_app</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('azioni.logout') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <v-container fluid fill-height align-start grid-list-lg>
        <router-view />
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import { Server } from 'http';
import { mapState } from 'vuex';
import i18n from '../plugins/i18n';

export default {
  name: 'Header',
  data() {
    return {
      selectedLanguage: "",
      langTag: "",
      drawerOpened: false,
      thereIsScadenza: false,
      centri_prova: [],
      selectedNumeroCentro: ""
    }
  },
  created() {
    this.$store.dispatch('loadAzienda').then(() => {
      this.fetchData();
    }).catch(e => {
      this.$snackbar.showServerError(e)
    })
    // if (this.shouldChangePassword) {
    //     this.$confirmDialog.showCustom(0, this.$t('errori.password_da_aggiornare'), {
    //         backgroundColor: 'gradient-warning',
    //         color: 'white',
    //         btns: [
    //             { text: this.$t('azioni.apri_impostazioni'), color: 'white', flat: true, click: () => this.$router.push('impostazioni') },
    //             { text: this.$t('azioni.ok'), color: 'white', flat: true }
    //         ]
    //     })
    //     this.shouldChangePassword = false
    // }

    this.$api.reports.getScadenza({
      p: 1,
      n: 11
    }).then(response => {
      var reportsTemp = [];

      reportsTemp = response.data.items

      if (reportsTemp) {
        this.reports = reportsTemp.sort((a, b) => new Date(this.$utils.date.reverseDayMonth(a.dettagli.validita_attestato)) - new Date(this.$utils.date.reverseDayMonth(b.dettagli.validita_attestato)));

        this.reports.forEach(report => {
          var timeMillis = new Date(this.$utils.date.reverseDayMonth(report.dettagli.validita_attestato));
          var timeNowMillis = Date.now() + 2629800000;

          // verifico se l'attestato è in scadenza
          if (timeMillis.getTime() <= timeNowMillis) {
            console.log("Il report scade tra pocoo");
            this.thereIsScadenza = true;
          }
        });

        if (this.thereIsScadenza) {
          this.$confirmDialog.showCustom(0, this.$t('errori.attestatiScadenza'), {
            backgroundColor: 'gradient-warning',
            color: 'white',
            btns: [
              { text: this.$t('azioni.apri_scadenza'), color: 'white', flat: true, click: () => this.$router.push('scadenza-attestati') },
              { text: this.$t('azioni.ok'), color: 'white', flat: true }
            ]
          })
        }
      }
    }).catch(e => {
      console.log(e)
      this.$snackbar.showServerError(e)
    })
  },

  computed: {
    drawerItems() {
      const updatedDrawerItems = {
        '/avvisi': {
          icon: 'event',
          title: this.$t('header.avvisi')
        },
        '/prenotazioni-calendar': {
          icon: 'event_note',
          title: this.$t('header.prenotazioni_calendar')
        },
        '/prenotazioni-advanced': {
          icon: 'event',
          title: this.$t('header.prenotazioni_advanced'),
          invisible: true
        },
        '/prenotazioni-map': {
          icon: 'map',
          title: this.$t('header.map')
        },
        '/agricoltori': {
          icon: 'people_outline',
          title: this.$t('header.clienti')
        },
        '/convenzioni': {
          icon: 'business',
          title: this.$t('header.convenzioni')
        },
        '/magazzino': {
          icon: 'inbox',
          title: this.$t('header.magazzino')
        },
        '/unita-mobili': {
          icon: 'local_shipping',
          title: this.$t('header.unita_mobili')
        },
        '/tecnici': {
          icon: 'people',
          title: this.$t('header.tecnici')
        },
        '/report': {
          icon: 'assignment',
          title: this.$t('header.report')
        },
        '/export-report': {
          icon: 'assignment',
          title: this.$t('header.file_trimestrali')
        },
        '/statistiche': {
          icon: 'bar_chart',
          title: this.$t('header.statistiche')
        },
        '/info': {
          icon: 'info',
          title: this.$t('header.info')
        },
        '/scadenza-attestati': {
          icon: 'warning',
          title: this.$t('header.scadenza_attestati')
        }
      }
      return updatedDrawerItems
    },
    ...mapState({
      azienda: state => state.global.azienda,
      _getShouldChangePassword: state => state.session.shouldChangePassword,
      isAbbonamentoExpired: state => state.session.isAbbonamentoExpired
    }),
    shouldChangePassword: {
      get() {
        return this._getShouldChangePassword
      },
      set(val) {
        this.$store.commit('SET_SHOULD_CHANGE_PASSWORD', val)
      }
    },
    drawerOpenedValue: {
      get() {
        return this.$vuetify.breakpoint.mdAndDown ? this.drawerOpened : true
      },
      set(val) {
        if (this.$vuetify.breakpoint.mdAndDown) this.drawerOpened = val
      }
    },
    drawerOpenedMiniVariant() {
      return this.$vuetify.breakpoint.lgAndUp ? this.drawerOpened : false
    }
  },
  mounted() {
    this.langTag = window.navigator.language.substring(0, 2);
    this.selectedLanguage = this.convertLangTag(this.langTag);
    window.addEventListener('languagechange', this.handleLanguageChange);
  },
  beforeDestroy() {
    window.removeEventListener('languagechange', this.handleLanguageChange)
  },
  methods: {
    handleLanguageChange() {
      this.changeLanguage(window.navigator.language.substring(0, 2))
      this.changeLanguage(this.langTag)
    },
    changeLanguage(language) {
      this.$i18n.locale = language
      this.langTag = language
      this.selectedLanguage = this.convertLangTag(this.langTag)
    },
    convertLangTag(tag) {
      switch (tag) {
        case "it":
          return "Italiano"
        case "en":
          return "English"
        case "de":
          return "Deutsch"
        case "pt":
          return "Português"
      }
    },

    getAvailableRelatedViews(route) {
      if (route === '/prenotazioni-calendar' || route === '/prenotazioni-advanced') {
        return {
          '/prenotazioni-calendar': this.drawerItems['/prenotazioni-calendar'],
          '/prenotazioni-advanced': this.drawerItems['/prenotazioni-advanced']
        }
      }
      return null
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/')
      })
    },

    cambiaCentro(centro)
    {
      let user = localStorage.getItem("username");
      let schema = centro.schema;

      this.$store.dispatch('cambioCentro', {
        username: user, 
        schema: schema
      }).then(() => {
          this.$store.dispatch('loadAzienda', true).catch(e => {
              this.$snackbar.showServerError(e)
          })
          // this.$router.push('avvisi')
          this.$router.go(0);
          this.selectedNumeroCentro = centro.numero_centro;
      }).catch(e => {
        console.log(e)
        this.$snackbar.showServerError(e)
      })
    },

    action() {
      return this.$api.manager.getCentri(localStorage.getItem("username"))
    },

    fetchData() {
      this.action()
        .then(response => {
            this.centri_prova = response.data;
            console.log("this.centri_prova", this.centri_prova)

            // Imposto numero_centro di default
            const centro = this.centri_prova.find(c => c.numero_centro === this.azienda.numero_centro);

            if (centro)
              this.selectedNumeroCentro = centro.numero_centro;
            else
              this.selectedNumeroCentro = this.centri_prova[0].numero_centro;
        }).catch(e => {
            this.$snackbar.showServerError(e)
            this.loading = false
        })
  }
  }
}
</script>
